export const getDocumentDateLabels = (documentType) => ({
  docDate: documentType?.docDateLabel?.trim() || 'Teljesítés dátuma',
  issueDate: documentType?.issueDateLabel?.trim() || 'Kiállítás dátuma',
  dueDate: documentType?.dueDateLabel?.trim() || 'Határidő',
});
